/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["i.definido[_ngcontent-%COMP%]{color:#1e90ff}i.finalizadoCorrecto[_ngcontent-%COMP%]{color:green}i.problem[_ngcontent-%COMP%]{color:red}i.finalizado[_ngcontent-%COMP%]{color:#daa520}"];
export { styles as styles };
